export const DELIVERY_STATUSES = {
  SELECTION: 'selection',
  REVIEW: 'review',
  DELIVERY: 'delivery',
  COMPLETED: 'completed',
} as const
